module.exports = __webpack_public_path__ + "static/media/IMG_3612.f0497390.jpg";